import { render, staticRenderFns } from "./SucaiList.vue?vue&type=template&id=2361e0e0&scoped=true&"
import script from "./SucaiList.vue?vue&type=script&lang=js&"
export * from "./SucaiList.vue?vue&type=script&lang=js&"
import style0 from "./SucaiList.vue?vue&type=style&index=0&id=2361e0e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2361e0e0",
  null
  
)

export default component.exports